import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHexagonCheck } from '@fortawesome/pro-regular-svg-icons';

const styles = {
  container: {
    display: 'flex',
    flexGrow: 1,
    gap: '20px',
    padding: '60px 20px',
    backgroundColor: '#ffffff',
    maxWidth: '1200px',
    margin: '0 auto',
  },
  iconWrapper: {
    width: '64px',
    height: '64px',
    borderRadius: '50%',
    backgroundColor: '#ff2300',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: '16px',
    color: '#ffffff',
    fontSize: '32px',
  },
  title: {
    fontSize: '32px',
    color: '#222',
    marginBottom: '16px',
    fontWeight: 400,
  },
  imageWrapper: {
    flex: 1,
    textAlign: 'center',
    marginBottom: '16px',
  },
  image: {
    maxWidth: '100%',
    height: 'auto',
    borderRadius: '8px',
  },
  listWrapper: {
    flex: 1,
    paddingLeft: '20px',
  },
  list: {
    listStyle: 'none',
    padding: 0,
    margin: 0,
  },
  listItem: {
    display: 'flex',
    alignItems: 'flex-start',
    marginBottom: '12px',
    fontSize: '20px',
    color: '#555',
    lineHeight: 1.5,
    fontWeight: 400,
  },
  checkIcon: {
    marginRight: '8px',
    marginTop: '6px',
    fontSize: '20px',
    color: '#ff2300',
  },
};

export default function SectionBodyRight({ icon, title, imageSrc, texts }) {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const containerStyle = {
    ...styles.container,
    flexDirection: isMobile ? 'column' : 'row',
  };

  return (
    <section style={containerStyle}>
      {isMobile ? (
        <>
          <div style={styles.iconWrapper}>
            <FontAwesomeIcon icon={icon} />
          </div>
          <h2 style={styles.title}>{title}</h2>
          <div style={styles.imageWrapper}>
            <img src={imageSrc} alt={title} style={styles.image} />
          </div>
          <div style={styles.listWrapper}>
            <ul style={styles.list}>
              {texts.map((text, i) => (
                <li key={i} style={styles.listItem}>
                  <FontAwesomeIcon
                    icon={faHexagonCheck}
                    style={styles.checkIcon}
                  />
                  {text}
                </li>
              ))}
            </ul>
          </div>
        </>
      ) : (
        <>
          <div style={styles.imageWrapper}>
            <img src={imageSrc} alt={title} style={styles.image} />
          </div>
          <div style={styles.listWrapper}>
            <div style={styles.iconWrapper}>
              <FontAwesomeIcon icon={icon} />
            </div>
            <h2 style={styles.title}>{title}</h2>
            <ul style={styles.list}>
              {texts.map((text, i) => (
                <li key={i} style={styles.listItem}>
                  <FontAwesomeIcon
                    icon={faHexagonCheck}
                    style={styles.checkIcon}
                  />
                  {text}
                </li>
              ))}
            </ul>
          </div>
        </>
      )}
    </section>
  );
}
